import type { QuickRebuttal } from "@expert/contentful";

/**
 * Format a Contentful `QuickRebuttal` doc into the numbered objection/response script the expert
 * hands to `onQuickRebuttal`. Shared by the legacy checklist footer (`FullOfferChecklistStep`) and
 * the Long Form AI footer so both produce byte-identical rebuttal copy.
 */
export function formatQuickRebuttal(doc?: QuickRebuttal): string {
    if (!doc?.objections?.length) return "";
    const q = (s = "") => `“${s}”`;
    return doc.objections
        .map((objection, i) => {
            const { title, responses = [] } = objection;
            const outerListItem = `${i + 1}. ${title === "Early Rebuttal" ? title : q(title)}`;
            const innerListItems = responses.map((response) => `- ${q(response.text)}`).join("\n");
            return innerListItems ? `${outerListItem}\n${innerListItems}` : outerListItem;
        })
        .join("\n\n");
}
